export class PaymentInventory {
  id: any;
  periodId: any;
  partnerId: any;
  status: any;
  logHistory: any;
}
